/* Filtrous Industries nav dropdown v1.2 (2026-09-04, Adelaide)
 * ADDITIVE: injects an "Industries" dropdown as the LAST item of the header
 * nav (after Contact). Loaded from snippets/customcode-scripts.liquid on
 * every page. Remove that script tag + this asset to revert.
 * Injects into BOTH header chromes — .fh3-nav (Liquid header,
 * sections/filtrous-header.liquid; hidden on app pages) AND .fv3-nav (built
 * late by sections/filtrous-v3-app.liquid on index/collection/product); the
 * observer stays alive so a re-rendered app header gets the menu back.
 * v1.2 (Adelaide): moved after Contact; fixed menu closing before a click
 * could land — the 8px gap between button and panel fired mouseleave mid-
 * travel. The gap is now hover-bridged and closing waits 250ms.
 * v1.3 (2026-09-14, Adelaide): Peptides listed first; text in Filtrous navy
 * #082F4B (brand guide) instead of #12222f; accessibility - the ARIA menu roles
 * (which promise arrow-key navigation this never had) replaced by a disclosure
 * button + list of links (aria-controls), Escape closes and returns focus to
 * the button, the panel closes when focus leaves it, visible focus rings, and
 * 44px-tall links. Enter/Space on the button toggle it explicitly (not relying
 * on a synthesised click); ArrowDown opens and focuses the first link, and
 * ArrowUp/ArrowDown move between links.
 * v1.4 (2026-09-17, Adelaide): Environmental and University & Government dropped
 * - Melibe 1.16 keeps only the industry pages that have application notes. */
(function () {
  'use strict';
  var INDUSTRIES = [
    ['Peptide Testing', '/pages/peptides'],   /* was 'Peptides' (2026-09-15, Adelaide) */
    ['Cannabis', '/pages/cannabis-testing'],
    ['Hospital & Healthcare', '/pages/hospital-healthcare'],
    ['Clinical Diagnostics', '/pages/clinical-diagnostics'],
    ['Cosmetic, Nutra & Food', '/pages/cosmetic-nutra-food'],
    ['Bioscience & Pharma', '/pages/bioscience-pharma']
  ];
  var uid = 0;
  var CHEV = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

  function addStyles() {
    if (document.getElementById('fin-dd-css')) return;
    var s = document.createElement('style');
    s.id = 'fin-dd-css';
    s.textContent = '.fin-dd{position:relative;display:inline-flex}' +
      '.fin-btn{display:inline-flex;align-items:center;gap:6px;padding:8px 16px;font-size:14.5px;font-weight:500;color:#082F4B;border-radius:8px;white-space:nowrap;background:none;border:0;cursor:pointer;font-family:inherit;transition:color .15s,background .15s;min-height:44px}' +
      '.fin-btn:hover,.fin-dd.open .fin-btn{color:#0d7d68;background:#f7fafb}' +
      '.fin-btn svg{transition:transform .15s}' +
      '.fin-dd.open .fin-btn svg{transform:rotate(180deg)}' +
      '.fin-btn:focus-visible,.fin-item:focus-visible{outline:3px solid #21D6B3;outline-offset:2px}' +
      '.fin-menu{list-style:none;margin:0;position:absolute;right:0;top:calc(100% + 8px);background:#fff;border:1px solid #e3e9ee;border-radius:12px;box-shadow:0 12px 32px rgba(8,47,75,.16);padding:8px;min-width:252px;display:none;z-index:130}' +
      '.fin-menu::before{content:"";position:absolute;top:-12px;left:0;right:0;height:12px}' +
      '.fin-dd.open .fin-menu{display:block}' +
      '.fin-item{display:flex;align-items:center;min-height:44px;box-sizing:border-box;padding:0 12px;border-radius:8px;font-size:14px;font-weight:500;color:#082F4B;text-decoration:none;white-space:nowrap}' +
      '.fin-item:hover{background:#f7fafb;color:#0d7d68}' +
      '@media (max-width:820px){.fin-menu{position:fixed;left:14px;right:14px;top:auto;min-width:0}}';
    document.head.appendChild(s);
  }

  function build() {
    var dd = document.createElement('div');
    dd.className = 'fin-dd';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fin-btn';
    var menuId = 'fin-menu-' + (++uid);
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', menuId);
    btn.innerHTML = 'Industries ' + CHEV;
    var menu = document.createElement('ul');
    menu.className = 'fin-menu';
    menu.id = menuId;
    for (var i = 0; i < INDUSTRIES.length; i++) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'fin-item';
      a.href = INDUSTRIES[i][1];
      a.textContent = INDUSTRIES[i][0];
      if (location.pathname === INDUSTRIES[i][1]) a.setAttribute('aria-current', 'page');
      li.appendChild(a);
      menu.appendChild(li);
    }
    dd.appendChild(btn);
    dd.appendChild(menu);
    var closeTimer = null;
    function setOpen(on) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      dd.classList.toggle('open', on);
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function closeSoon() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { setOpen(false); }, 250);
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      setOpen(!dd.classList.contains('open'));
    });
    /* Keyboard: do not rely on the browser synthesising a click from Enter/Space. */
    var links = function () { return Array.prototype.slice.call(menu.querySelectorAll('.fin-item')); };
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        setOpen(!dd.classList.contains('open'));
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        setOpen(true);
        var l = links(); if (l[0]) l[0].focus();
      }
    });
    menu.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var l = links(), i = l.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      l[(i + (e.key === 'ArrowDown' ? 1 : l.length - 1)) % l.length].focus();
    });
    dd.addEventListener('mouseenter', function () { setOpen(true); });
    dd.addEventListener('mouseleave', closeSoon);
    document.addEventListener('click', function (e) {
      if (!dd.contains(e.target)) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dd.classList.contains('open')) {
        var inside = dd.contains(document.activeElement);
        setOpen(false);
        if (inside) btn.focus();
      }
    });
    dd.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !dd.contains(e.relatedTarget)) setOpen(false);
    });
    return dd;
  }

  function inject() {
    var navs = document.querySelectorAll('.fh3-nav, .fv3-nav');
    for (var i = 0; i < navs.length; i++) {
      if (navs[i].querySelector('.fin-dd')) continue;
      addStyles();
      navs[i].appendChild(build());
    }
  }

  function boot() {
    inject();
    new MutationObserver(inject).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
